const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (!envUrl) return '';
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && !window.location.hostname.includes('preview.emergentagent.com')) {
    return '';
  }
  return envUrl;
};

const getWsUrl = () => {
  const base = getApiUrl();
  if (!base) {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window.location.host}`;
  }
  return base.replace('https://', 'wss://').replace('http://', 'ws://');
};

export const API_BASE = getApiUrl();
export const API = `${API_BASE}/api`;
export const WS_URL = getWsUrl();
